module.exports = __webpack_public_path__ + "img/2020-06-16.c427dd14.jpg";